import { createTheme } from '@mui/material/styles';

// Define your theme settings here
const theme = createTheme({
  palette: {
    primary: {
      main: '#61FE6F',
      lighterShade: '#B6FFBD' // Set your primary color here
    },
    secondary: {
      main: '#dc004e', // Set your secondary color here
    },
    background: {
      default: '#f5f5f5', // Default background color
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif', // Default font family
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& :-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px white inset',
            WebkitTextFillColor: 'black',
          },
        },
      },
    },
  },
});

// Custom theme to style disabled inputs
export const ViewOnlyPages = createTheme(theme, {
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root.Mui-disabled': { color: '#666666' },
          '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: '#232c3e' },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: { '&.Mui-disabled': { WebkitTextFillColor: '#232c3e' } },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: { '&.Mui-disabled': { color: "#61FE6F" } },
      },
    },
  },
});

export default theme;
